import { PAGE_TYPE } from '@utils/constants';
import injectorServer from '../common/injectorServer';
import Sharing from './Sharing';
import TempDashboard from './TempDashboard';
import Dashboard from './Dashboard';

export const NocSharing = injectorServer({
}, {
  pageType: PAGE_TYPE.SHARING,
})(Sharing);

export const TempDashboardNoc = injectorServer({
}, {
  pageType: PAGE_TYPE.TEMP_DASHBOARD,
})(TempDashboard);

export const DashboardNoc = injectorServer({
}, {
  pageType: PAGE_TYPE.SAVED_DASHBOARD,
})(Dashboard);

export {default as NocSavedDashboard} from './NocSavedDashboard';

export { default as TempNocDrilldownDashboard } from './TempNocDrilldownDashboard';
